import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import './CartPage.css';

const CartPage = () => {
  const location = useLocation();
  const [cartItems, setCartItems] = useState(() => {
    const savedCart = localStorage.getItem('cartItems');
    return savedCart ? JSON.parse(savedCart) : location.state?.cartItems || [];
  });

  // Save cart items to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('cartItems', JSON.stringify(cartItems));
  }, [cartItems]);

  const updateQuantity = (id, change) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.id === id
          ? { ...item, quantity: Math.max(1, item.quantity + change) }
          : item
      )
    );
  };

  const removeItem = (id) => {
    setCartItems(cartItems.filter((item) => item.id !== id));
  };

  const total = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);

  return (
    <div className="cart-container">
      <h1 className="cart-title">🛒 Your Cart</h1>

      {cartItems.length === 0 ? (
        <p className="empty-cart">Your cart is empty.</p>
      ) : (
        <>
          <table className="cart-table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Price</th>
                <th>Quantity</th>
                <th>Subtotal</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {cartItems.map((item) => (
                <tr key={item.id}>
                  <td className="product-details">
                    <img src={item.image} alt={item.name} className="cart-image" />
                    <span>{item.name}</span>
                  </td>
                  <td>₹{item.price}</td>
                  <td>
                    <button className="quantity-btn" onClick={() => updateQuantity(item.id, -1)}>➖</button>
                    <span className="quantity">{item.quantity}</span>
                    <button className="quantity-btn" onClick={() => updateQuantity(item.id, 1)}>➕</button>
                  </td>
                  <td>₹{item.price * item.quantity}</td>
                  <td>
                    <button className="remove-btn" onClick={() => removeItem(item.id)}>❌ Remove</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="cart-totals">
            <h3>Total: ₹{total}</h3>
            <button className="checkout-btn">✅ Proceed to Checkout</button>
          </div>
        </>
      )}

      <Link to="/products" className="back-btn">⬅️ Back to Products</Link>
    </div>
  );
};

export default CartPage;
